import React, { useState, useLayoutEffect } from 'react';
import QuestionList from './QuestionList';
import './App.css';

function initialTheme() {
  try {
    const saved = localStorage.getItem('jeopardymd-theme');
    if (saved === 'dark' || saved === 'light') return saved;
  } catch { /* Storage may be unavailable in private browsing. */ }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export default function App() {
  const [theme, setTheme] = useState(initialTheme);
  useLayoutEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'dark' ? '#171b18' : '#fdfdfb');
    try { localStorage.setItem('jeopardymd-theme', theme); } catch { /* The toggle still works without storage. */ }
  }, [theme]);
  return <QuestionList theme={theme} onThemeChange={setTheme} />;
}
